let arrow = document.querySelectorAll(".iocn-link");
for (var i = 0; i < arrow.length; i++) {
    arrow[i].addEventListener("click", (e) => {
        let arrowParent = e.target.closest('li'); //selecting main parent of arrow
        arrowParent.classList.toggle("showMenu");
    });
}
 
 
 

let sidebar = document.querySelector(".sidebar");
let sidebarBtn = document.querySelector(".bx-menu");
let newEnquiry;
if (document.getElementById('newEnquiry')) {
    newEnquiry = document.getElementById('newEnquiry').value;
}
if (sidebarBtn) {
    sidebarBtn.addEventListener("click", () => {
        sidebar.classList.toggle("side-close");
        $(".side-pnl")[0].classList.toggle("expend-sidepnl");
        $("#area").next('span.select2').css('width', '425px');
        if (sidebar.classList.contains('side-close')) {
            sidebarBtn.classList.remove("fa-times");
            sidebarBtn.classList.add("fa-bar");
            if (newEnquiry == "yes") {
                $(".fa-envelope")[0].classList.add("faEnvelope");
            } else if (newEnquiry == "no") {
                $(".fa-envelope")[0].classList.remove("faEnvelope");
            }
        } else {
            sidebarBtn.classList.add("fa-times");
            sidebarBtn.classList.remove("fa-bar");
            $(".fa-envelope")[0].classList.remove("faEnvelope");
        }
        // 
    });
}
